/** @type {import('./global')} */
import React, { createContext, useState } from "react";

/**
 * @type {React.Context<RiContextsType>}
 */
export const RiContexts = createContext();

/**
 * @typedef RiContextsType
 * @property {string[]} eventKey
 * @property {React.Dispatch<React.SetStateAction<string>>} setEventkey
 * @property {boolean} showRiRecommendation
 * @property {React.Dispatch<React.SetStateAction<boolean>>} setShowRiRecommendation
//  * @property {boolean} showBulkModal
//  * @property {React.Dispatch<React.SetStateAction<boolean>>} setShowBulkModal
//  * @property {boolean} showScopeModal
//  * @property {React.Dispatch<React.SetStateAction<boolean>>} setShowScopeModal
//  * @property {string[]} SelectedAccounts
//  * @property {React.Dispatch<React.SetStateAction<string>>} setSelectedAccounts
//  * @property {string[]} selectedReservation
//  * @property {React.Dispatch<React.SetStateAction<string>>} setSelectedReservation
//  * @property {string[]} selectedVMFamily
//  * @property {React.Dispatch<React.SetStateAction<string>>} setSelectedVMFamily
//  * @property {string} selectedTitle
//  * @property {React.Dispatch<React.SetStateAction<string>>} setSelectedTitle
//  * @property {string[]} SelecInstanceTypents
//  * @property {React.Dispatch<React.SetStateAction<string>>} setSelecInstanceTypents
//  * @property {string[]} selectedRegions
//  * @property {React.Dispatch<React.SetStateAction<string>>} setSelectedRegions
 */


/**
 * @returns {RiContextsType}
 */
export const useRIContexts = () => {
  const [eventkey, setEventkey] = useState("Rightsizing");

  /** @type {UseState<string[]>} */
  const [SelectedAccounts, setSelectedAccounts] = useState([]);

  /** @type {UseState<string[]>} */
  const [selectedReservation, setSelectedReservation] = useState([]);

  /** @type {UseState<string[]>} */
  const [selectedVMFamily, setSelectedVMFamily] = useState([]);

  /** @type {UseState<string>} */
  const [selectedTitle, setSelectedTitle] = useState("");

  /** @type {UseState<string[]>} */
  const [SelecInstanceTypents, setSelecInstanceTypents] = useState([]);

  /** @type {UseState<string[]>} */
  const [selectedRegions, setSelectedRegions] = useState([]);

  /** @type {UseState<string[]>} */
  const [SelectedplateformType, setSelectedplateformType] = useState([]);

  /** @type {UseState<boolean[]>} */
  const [showRiRecommendation, setShowRiRecommendation] = useState(false);

  /** @type {UseState<boolean[]>} */
  const [showBulkModal, setShowBulkModal] = useState(false);

  /** @type {UseState<boolean[]>} */
  const [showScopeModal, setShowScopeModal] = useState(false);

  /** @type {UseState<string[]>} */
  const [totalCount, setTotalCount] = useState([0]);

  /** @type {UseState<string[]>} */
  const [accountID, setAccountID] = useState(0);
  
  /** @type {UseState<string[]>} */
  const [tableType, setTableType] = useState("scope");

  /** @type {UseState<string[]>} */
  const [scopeName, setScopeName] = useState("");

  /** @type {UseState<string[]>} */
  const [subscriptionId, setSubscriptionId] = useState("");

  /** @type {UseState<string[]>} */
  const [rgName, setRgName] = useState("");

  /** @type {UseState<string[]>} */
  const [instanceType, setInstanceType] = useState("");

  /** @type {UseState<string[]>} */
  const [onDemandH, setOnDemandH] = useState("");

  /** @type {UseState<string[]>} */
  const [onDemandC, setOnDemandC] = useState("");

  /** @type {UseState<string[]>} */
  const [platform, setPlatform] = useState("");

  /** @type {UseState<string[]>} */
  const [region, setRegion] = useState("");

  /** @type {UseState<string[]>} */
  const [resourceId, setResourceId] = useState("");

  /** @type {UseState<string[]>} */
  const [quantity_to_purchase, setQuantity_to_purchase] = useState("");

  /** @type {UseState<string[]>} */
  const [instance_flexibility, setInstance_flexibility] = useState("");
  /** @type {UseState<string[]>} */
  const [VMSeries, setVMSeries] = useState("");
  /** @type {UseState<string[]>} */
  const [Tenancy, setTenancy] = useState("");

  /** @type {UseState<string[]>} */
  const [tab, setTab] = useState("ri");
    /** @type {UseState<string[]>} */
    const [selectedTags, setSelectedTags] = useState([
      {
        filterOn: "",
        filterType: 'include',
        values: [],
      }
    ]);
      /** @type {UseState<string[]>} */
  const [selectedAccounts, setSelectedAccount] = useState([]);
  const [totalValue, setTotalValue] = useState([]);

    /** @type {UseState<string[]>} */
    const [selectedResourceGroup, setSelectedResourceGroup] = useState([]);
  /** @type {UseState<string[]>} */

  return {
    totalValue,
    setTotalValue,
    selectedAccounts,
    setSelectedAccount,
    selectedResourceGroup,
    setSelectedResourceGroup,
    selectedTags,
    setSelectedTags,
    Tenancy,
    setTenancy,
    VMSeries,
    setVMSeries,
    tab,
    setTab,
    quantity_to_purchase,
    setQuantity_to_purchase,
    instance_flexibility,
    setInstance_flexibility,
    resourceId,
    setResourceId,
    region,
    setRegion,
    platform,
    setPlatform,
    instanceType,
    setInstanceType,
    onDemandH,
    setOnDemandH,
    onDemandC,
    setOnDemandC,
    scopeName,
    setScopeName,
    subscriptionId,
    setSubscriptionId,
    rgName,
    setRgName,
    eventkey,
    setEventkey,
    SelectedAccounts,
    setSelectedAccounts,
    SelecInstanceTypents,
    setSelecInstanceTypents,
    selectedRegions,
    setSelectedRegions,
    SelectedplateformType,
    setSelectedplateformType,
    showRiRecommendation,
    setShowRiRecommendation,
    showBulkModal,
    setShowBulkModal,
    showScopeModal,
    setShowScopeModal,
    totalCount,
    setTotalCount,
    accountID,
    setAccountID,
    tableType,
    setTableType,
    selectedVMFamily,
    setSelectedVMFamily,
    selectedReservation,
    setSelectedReservation,
    selectedTitle,
    setSelectedTitle,
  };
};

export const RiProvider = ({ children }) => {
  const context = useRIContexts();

  return (
    <>
      <RiContexts.Provider value={context}>{children}</RiContexts.Provider>
    </>
  );
};
